import axios from "axios";
import handleError from "./handleerror";

const BW_API_URL = process.env.REACT_APP_BW_API_URL;
const BW_LOYVERSE_API_URL = process.env.REACT_APP_BW_LOYVERSE_API_URL;

const CLIENT_AUTH = {
    ClientKey: process.env.REACT_APP_BW_CLIENT_KEY,
    ClientSecret: process.env.REACT_APP_BW_CLIENT_SECRET,
};
const AUTH_HEADER = {
    headers: { Accept: "application/json", "Content-Type": "application/json" },
};
const BW_LOYVERSE_AUTH_HEADER = {
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${process.env.REACT_APP_BW_CLIENT_KEY}:${process.env.REACT_APP_BW_CLIENT_SECRET}`,
    },
};

const getbwapiheaders = (authtoken) => {
    if (authtoken)
        return {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + authtoken,
            },
        };
    else
        return {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        };
};

// HTTP POST Request for auth api call - Returns Resolved or Rejected Promise
export const auth = () => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${BW_API_URL}${"/OAuth/authorize"}`, CLIENT_AUTH, AUTH_HEADER)
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};

// HTTP POST Request for signin api call - Returns Resolved or Rejected Promise
export const signin = (data, authtoken) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${BW_API_URL}${"/OAuth/login"}`, data, getbwapiheaders(authtoken))
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};

// HTTP GET Request - Returns Resolved or Rejected Promise
export const get = (path, auhtoken) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${BW_API_URL}${path}`, getbwapiheaders(auhtoken))
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};

// HTTP POST Request - Returns Resolved or Rejected Promise
export const post = (path, data, auhtoken) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${BW_API_URL}${path}`, data, getbwapiheaders(auhtoken))
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};

// HTTP POST Request - Returns Resolved or Rejected Promise
export const postbwloyverse = (path, data, auhtoken) => {
    return new Promise((resolve, reject) => {
        resolve({
            data: {}
        })
         axios
            .post(`${BW_LOYVERSE_API_URL}${path}`, data, BW_LOYVERSE_AUTH_HEADER)
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};

// HTTP GET Request - Returns Resolved or Rejected Promise
export const hash = (path) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${BW_API_URL}${path}`, getbwapiheaders())
            .then((response) => resolve(response.data))
            .catch((error) => reject(handleError(error)));
    });
};
